<script lang="ts">

    export let opacity: number = 0.5;
</script>

<span style="opacity: {opacity}">
    <slot />
</span>